import { render, staticRenderFns } from "./ConfigAccountNumber.vue?vue&type=template&id=bf0ff650&scoped=true&"
import script from "./ConfigAccountNumber.vue?vue&type=script&lang=js&"
export * from "./ConfigAccountNumber.vue?vue&type=script&lang=js&"
import style0 from "./ConfigAccountNumber.vue?vue&type=style&index=0&id=bf0ff650&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0ff650",
  null
  
)

export default component.exports